import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

import { LANDING_COLORS } from '../../../constants'

/** 안내 문구 강조색 — PriceSection 전용 (시안값) */
const NOTICE_WARN = '#C2846B'

export const PriceContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  padding: 60px 0;
  background-color: ${COLORS.bgInverse};
`

export const PriceTitle = styled.h2`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -0.42px;
  text-align: center;
  color: ${COLORS.textInverse};
`

export const ReceiptBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
  background-color: ${COLORS.bgWhite};
`

export const ReceiptTop = styled.div`
  height: 16px;
  background-color: ${COLORS.bgWhite};
`

export const ItemRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 30px;
  background-color: ${COLORS.bgWhite};
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.27px;
  color: ${LANDING_COLORS.brand};
`

export const FeeRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 30px 20px;
  background-color: ${COLORS.bgWhite};
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.27px;
`

export const FeeLabel = styled.span`
  color: ${COLORS.textTertiary};
`

export const FeeValue = styled.span`
  color: ${COLORS.textSecondary};
`

export const ReceiptDivider = styled.div`
  height: 0;
  margin: 0 25px;
  border-top: 1px dashed ${COLORS.strokeInput};
  background-color: ${COLORS.bgWhite};
`

export const TotalBoxWrap = styled.div`
  display: flex;
  padding: 20px 24px;
  background-color: ${COLORS.bgWhite};
`

export const TotalBox = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  padding: 16px 40px;
  border-radius: 14px;
  background-color: ${COLORS.bgInverse};
`

export const TotalLabel = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: -0.24px;
  color: ${COLORS.textInverse};
`

export const TotalAmount = styled.p`
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: -0.42px;
  color: ${LANDING_COLORS.brand};
`

export const ReceiptBottom = styled.img`
  width: 100%;
  height: 9px;
  transform: scaleY(-1);
`

export const NoticeList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
`

export const NoticeItem = styled('li', {
  shouldForwardProp: (prop) => prop !== 'warn',
})<{ warn: boolean }>`
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: -0.21px;
  color: ${({ warn }) => (warn ? NOTICE_WARN : COLORS.textMuted)};
`
